<template>
	<div class="Reason Popup wrapper" :class="{ active: isShow }">
		<div class="Header__detail" v-if="iframeData">
			<div class="left-btn-group">
				<button @click="goBack">
					<img src="@/assets/svg/arrow-back.svg" alt="back" />
				</button>
				<h5>
					{{ iframeData.name }}
				</h5>
			</div>
		</div>
		<iframe
			id="iframe"
			v-if="isShow"
			style="width: 100%; height: 90%"
			:src="iframeData.link"
		></iframe>
	</div>
</template>

<script>
export default {
	props: {
		iframeData: {
			type: Object,
			default: () => {},
		},
		isShow: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		goBack() {
			this.$emit('hide')
		},
	},
}
</script>

<style lang="scss" scoped>
.wrapper {
	background: white !important;
}
.Reason {
	.AppContainer {
		h2 {
			font-size: 1.375rem;
			font-weight: 700;
			padding-left: 20px;
			margin-top: 10px;
		}
		.Form__enter-content {
			input {
				&.error {
					border-bottom: 1px solid #ff5746;
				}
			}
			.flex {
				width: 100%;
				margin-top: 8px;
				img {
					width: 12px;
					height: 12px;
					margin-right: 5px;
				}
				p {
					font-size: 0.75rem;
					font-weight: 400;
					display: flex;
					align-items: center;
					height: auto;
				}
				span {
					font-size: 0.75rem;
					display: inline-block;
					color: #999;
				}
			}
		}
	}
}
</style>
